export default (el) => {
  const words = el.querySelectorAll('.word');

  words.forEach((word, index) => {
    setTimeout(() => {
      word.classList.add('fade-in');
    }, 1200 * index);
  });

  setTimeout(() => {
    const form = el.querySelector('#wps-form');
    if (form) form.classList.add('fade-in-form');
  }, 2500);
};
